
import { Fraga } from "@/types/riskbedomning";

export const waterRiskFragor: Fraga[] = [
  {
    id: "drunkningsrisk",
    text: "Finns det risk för drunkning vid arbete nära vatten?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan brist på flythjälp, räddningsutrustning eller organiserade rutiner för snabb undsättning leda till allvarliga konsekvenser vid fall i vatten eller annan nödsituation?",
      "Finns det risk att räddningsutrustning inte är lättillgänglig?",
      "Finns det risk att säkerhetsavstånd mellan arbete och vattenkällor saknas?"
    ]
  },
  {
    id: "dykarbete",
    text: "Finns det risk att dykarbete ska utföras?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Kan bristande eller otydliga kommunikationsprocedurer mellan dykare och ytan leda till missförstånd, fördröjd respons eller fara vid nödsituation under vattenarbete?",
      "Finns det risk att riskbedömning för specifika dykarbeten saknas eller är otillräcklig?"
    ]
  },
  {
    id: "kassunarbete",
    text: "Finns det risk att kassunarbete (arbete i förhöjt lufttryck) ska utföras?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Riskerar arbete under tryck att sakna dekompressionsrutiner, utbildning och medicinsk beredskap?",
      "Finns det risk för kassunsjuka utan adekvata förebyggande åtgärder?",
      "Finns det risk att medicinsk beredskap för tryckrelaterade olyckor är otillräcklig?"
    ]
  }
];
